import NotFoundPage from '@shared/components/common/NotFoundPage';
import { ADMIN_ROUTES } from '@shared/configs/constants';

export default function AdminNotFoundPage() {
    return (
        <div className='h-screen'>
            <NotFoundPage homeHref={ADMIN_ROUTES.userManagement.href} />
        </div>
    );
}
